import { Controller, useFormContext } from "react-hook-form";
import { DropdownSelect, ErrorMessage, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { platformGoalsOptions } from "../../fixtures";
import { SignUpOperatorFormData } from "../types";

export const PlatformGoalsField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">What specific goals do you aim to accomplish by acquiring this software?</Typography>
      <Controller
        name="platformGoals"
        control={control}
        render={({ field }) => (
          <DropdownSelect
            className="w-full"
            hasError={!!errors.platformGoals}
            placeholder="Select Answer"
            options={platformGoalsOptions}
            value={field.value}
            onChange={(value) => field.onChange(value)}
            position="bottom"
          />
        )}
      />
      <ErrorMessage errors={errors} name="platformGoals" />
    </div>
  );
};
